
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import  themen  from 'theme/styles/styled-colors';
import  * as theme  from 'react-syntax-highlighter/dist/esm/styles/hljs';
import SyntaxHighlighter from 'react-syntax-highlighter';
import Img from 'theme/components/shared/Img'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "atlas-ranger-authorizer"
    }}>{`Atlas Ranger Authorizer`}</h1>
    <h2 {...{
      "id": "setting-up-apache-atlas-to-use-apache-ranger-authorization"
    }}>{`Setting up Apache Atlas to use Apache Ranger Authorization`}</h2>
    <p>{`As detailed in `}<a parentName="p" {...{
        "href": "#/AuthorizationModel"
      }}>{`Atlas Authorization Model`}</a>{`, Apache Atlas supports pluggable authorization
model. Apache Ranger provides an authorizer implementation that uses Apache Ranger policies for authorization. In
addition, the authorizer provided by Apache Ranger audits all authorizations into a central audit store.`}</p>
    <h3 {...{
      "id": "configure-apache-atlas"
    }}>{`Configure Apache Atlas`}</h3>
    <p>{`To configure Apache Atlas to use Apache Ranger authorizer, please follow the instructions given below:`}</p>
    <ul>
      <li parentName="ul">{`Include the following property in atlas-application.properties config file:`}</li>
    </ul>
    <SyntaxHighlighter wrapLines={true} language="shell" style={theme.dark} mdxType="SyntaxHighlighter">
   {`atlas.authorizer.impl=ranger`}
    </SyntaxHighlighter>
    <p>{`   If you use Apache Ambari to deploy Apache Atlas and Apache Ranger, enable Atlas plugin in configuration pages for
Apache Ranger.`}</p>
    <ul>
      <li parentName="ul">{`Include libraries of Apache Ranger plugin in libext directory of Apache Atlas`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`<Atlas installation directory>`}</inlineCode>{`/libext/ranger-atlas-plugin-impl/`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`<Atlas installation directory>`}</inlineCode>{`/libext/ranger-atlas-plugin-shim-`}<version />{`.jar`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`<Atlas installation directory>`}</inlineCode>{`/libext/ranger-plugin-classloader-`}<version />{`.jar`}</li>
        </ul>
      </li>
    </ul>
    <ul>
      <li parentName="ul">{`Include configuration files for Apache Ranger plugin in configuration directory of Apache Atlas - typically under /etc/atlas/conf directory. For more details on configuration file contents, please refer to appropriate documentation in Apache Ranger.`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`<Atlas configuration directory>`}</inlineCode>{`/ranger-atlas-audit.xml`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`<Atlas configuration directory>`}</inlineCode>{`/ranger-atlas-security.xml`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`<Atlas configuration directory>`}</inlineCode>{`/ranger-policymgr-ssl.xml`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`<Atlas configuration directory>`}</inlineCode>{`/ranger-security.xml`}</li>
        </ul>
      </li>
    </ul>
    <h3 {...{
      "id": "apache-ranger-authorization-policy-model-for-apache-atlas"
    }}>{`Apache Ranger authorization policy model for Apache Atlas`}</h3>
    <p>{`Apache Ranger authorization policy model for Apache Atlas supports 3 resource hierarchies, to control access to: types,
entities and admin operations. Following images show various details of each type of policy in Apache Ranger.`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Types`}</strong></li>
    </ul>
    <p>{`Following authorization policy allows user 'admin' to create/update/delete any classification type.`}</p>
    <Img alt="Apache Ranger policy for type operations" src={`/images/twiki/ranger-policy-types.png`} width="600" mdxType="Img" />
    <hr></hr>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Entity`}</strong></li>
    </ul>
    <p>{`Following authorization policy allows user 'admin' perform all operations on metadata entities of Hive database named "my_db".`}</p>
    <Img alt="Apache Ranger policy for entity operations" src={`/images/twiki/ranger-policy-entities.png`} width="600" mdxType="Img" />
    <hr></hr>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Admin Operations`}</strong>{`
Following authorization policy allows user 'admin' to perform export/import admin operations.`}</li>
    </ul>
    <Img alt="Apache Ranger policy for admin operations" src={`/images/twiki/ranger-policy-admin.png`} width="600" mdxType="Img" />
    <hr></hr>
    <h3 {...{
      "id": "apache-ranger-access-audit-for-apache-atlas-authorizations"
    }}>{`Apache Ranger access audit for Apache Atlas authorizations`}</h3>
    <p>{`Apache Ranger authorization plugin generates audit logs with details of the access authorized by the plugin. The details
include the object accessed (e.g. hive_table with ID cost_savings.claim_savings@cl1), type of access performed (e.g.
entity-add-classification, entity-remove-classification), name of the user, time of access and the IP address the access
request came from - as shown in the following image.`}</p>
    <Img alt="Apache Ranger audit " src={`/images/twiki/ranger-audit.png`} width="800" mdxType="Img" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;